<template>
  <div class="shop_detail">
    <div class="title">{{bulletinDetail.title}}</div>
    <div class="time">{{bulletinDetail.start_time_text}}</div>
    <div v-html="description" class="n_html shop_detailsTop"></div>
  </div>
</template>

<script>
export default {
  name: 'refresh',
  data() {
    return {
      bulletinDetail: '',
      description: '',
    }
  },
  created() {
    this.id = this.$route.query.id
    this.initFg()
  },
  methods: {
    // 初始化
    initFg() {
      this.http('ClientBulletin.bulletinDetail', {
        id: this.id,
      }).then((e) => {
        if (e.status == 200) {
          this.bulletinDetail = e.content
          this.description = e.content.content
        }
      })
    },
  },
}
</script>

<style>
.shop_detailsTop img {
  width: 100% !important;
  height: 100%;
}
.shop_detailsTop .n_html p {
  margin: 0;
}
.shop_detailsTop .n_html p img {
  width: 100% !important;
  vertical-align: top;
}
.shop_detailsTop .n_html img {
  width: 100% !important;
  vertical-align: top;
}
</style>

<style lang="scss" scoped>
.shop_detail {
  padding: 0 30px;
}
.n_html {
  width: 100%;
  overflow: hidden;
  margin-bottom: 150px;
}
.n_html img {
  width: 100%;
}

.title {
  font-size: 46px;
  font-weight: 800;
  color: #333333;
  line-height: 46px;
  margin-bottom: 16px;
  margin-top: 35px;
}
.time {
  font-size: 24px;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
  margin-bottom: 48px;
}
</style>